import ApiClient from '../../API/api';

const GET_CART_ENDPOINT = 'cart';
const PUT_PRODUCT_EQUIVALENCE_CHARGE_ENDPOINT = 'cart/product/:productId/recargo';
const DELETE_PRODUCT_ENDPOINT = 'cart/product/:productId';
const PUT_PRODUCT_QUANTITY_ENDPOINT = 'cart/product/:productId/quantity';
const PUT_PRODUCT_RECETA_ENDPOINT = 'cart/product/:productId/receta';
const GET_PRODUCT_ESPECIES_ENDPOINT = 'cart/product/:productId/especies';
const PUT_PRODUCT_PRECIO_ENDPOINT = 'cart/product/:productId/precio';

export class CartRepository {
  static get() {
    return ApiClient.performRequest(GET_CART_ENDPOINT);
  };

  static setEquivalenceCharge(productId, equivalenceCharge) {
    return ApiClient.performRequest(PUT_PRODUCT_EQUIVALENCE_CHARGE_ENDPOINT,
      {
        method: 'PUT',
        pathParams: { productId: productId },
        queryParams: { recargo: equivalenceCharge }
      }
    );
  };

  static async removeProduct(productId) {
    return ApiClient.performRequest(
      DELETE_PRODUCT_ENDPOINT,
      { method: 'DELETE', pathParams: { productId: productId } }
    );
  };

  /** Datos de receta de la línea (modo comercial): { especie, numAnimales, animalId }, nulos = quitar. */
  static setReceta(productId, receta) {
    return ApiClient.performRequest(
      PUT_PRODUCT_RECETA_ENDPOINT,
      { method: 'PUT', pathParams: { productId: productId }, body: receta }
    );
  };

  /** Precio unitario y/o dto.1 manual de la línea (comercial con permiso); ambos null = restaurar tarifa. */
  static setPrecioManual(productId, precio) {
    return ApiClient.performRequest(
      PUT_PRODUCT_PRECIO_ENDPOINT,
      { method: 'PUT', pathParams: { productId: productId }, body: precio }
    );
  };

  /** Especies que admite la línea (las compatibles del artículo, o todas si no tiene). */
  static getEspecies(productId) {
    return ApiClient.performRequest(
      GET_PRODUCT_ESPECIES_ENDPOINT,
      { pathParams: { productId: productId } }
    );
  };

  static async updateProductQuantity(productId, quantity) {
    return ApiClient.performRequest(
      PUT_PRODUCT_QUANTITY_ENDPOINT,
      {
        method: 'PUT',
        pathParams: { productId: productId },
        queryParams: { quantity: quantity }
      }
    );
  };
}
